var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "DoneTaskSettings" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "done-task-card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c(
          "div",
          { staticClass: "status-option", on: { click: _vm.toggleStatus } },
          [
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "option-switch" },
              [
                _c("a-switch", {
                  model: {
                    value: _vm.switchState,
                    callback: function ($$v) {
                      _vm.switchState = $$v
                    },
                    expression: "switchState",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "loading-spinner" }, [
          _c("span", { staticClass: "material-icons spin" }, [
            _vm._v("refresh"),
          ]),
          _vm._v(" Kaydediliyor...\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-alert" }, [
      _c("div", { staticClass: "info-icon" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("info")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-content" }, [
        _c("div", { staticClass: "info-title" }, [
          _vm._v("Görev Kapatma İşlemi"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-message" }, [
          _vm._v(
            "\n                Kapatılacak görevlerin başarılı mı başarısız mı olduğunu ve açıklama girerek kapatıldığını sormak için kullanılır.\n            "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "card-title" }, [_vm._v("Done Task Modal")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("settings")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option-content" }, [
      _c("div", { staticClass: "option-label" }, [
        _vm._v("Kapatma Durumu Sorulsun"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option-description" }, [
        _vm._v(
          "\n                        Görevi kapatırken kapatma durumunu girebilmek için bu seçeneği aktif et. Aktif olmadığı zaman kart hiçbir soru sormadan direkt kapatılır.\n                    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }